<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="手机号">
              <a-input
                placeholder="请输入手机号"
                v-model="queryParam.mobile"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="短信状态">
              <a-select
                placeholder="请选择短信状态"
                v-model="queryParam.status"
              >
                <a-select-option :value="0">失败</a-select-option>
                <a-select-option :value="1">成功</a-select-option>
                <a-select-option value="null">全部</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="选择日期：">
              <a-range-picker
                v-model="createTime"
                :placeholder="['开始日期', '结束日期']"
                :value="createValue"
                @change="handleChange"
                :format="format"
              />
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="短信内容">
              <a-input
                placeholder="请输入短信内容"
                v-model="queryParam.content"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <a-button @click="vertical" type="primary" icon="plus">单条发送</a-button>
      <a-button @click="retrieveBatch" type="primary" icon="plus"
        >批量重发</a-button
      >
      <a-button @click="showDialog = true" type="primary" icon="plus"
        >批量发送</a-button
      >

      <!-- 导入 -->
      <a-modal
        title="上传文件"
        :visible="showDialog"
        @cancel="showDialog = false"
      >
        <a-upload-dragger
          name="file"
          :multiple="true"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :before-upload="beforeUpload"
          :remove="handleRemove"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">点击或拖拽上传文件</p>
        </a-upload-dragger>
        <a
          @click="handleExportExcel('短信模板')"
          style="float: right; margin-top: 0px; cursor: pointer; color: #1890ff"
        >
          点击下载模板
        </a>
        <template slot="footer">
          <a-button key="back" @click="showDialog = false"> 取消 </a-button>
          <a-button
            :disabled="fileList.length === 0"
            :loading="uploading"
            key="submit"
            type="primary"
            icon="download"
            @click="upload"
          >
            立即发送
          </a-button>
        </template>
      </a-modal>
      <!-- 高级查询区域 -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="retrieveBatch" key="1"
            ><a-icon type="delete" />批量重发</a-menu-item
          >
          <a-menu-item
            style="margin-top: 5px"
            icon="upload"
            @click="showDialog = true"
            key="2"
            ><a-icon type="delete" />批量发送</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown> -->
    </div>
    <!-- 导入 -->

    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      class="j-table-force-nowrap"
      @change="handleTableChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="retransmission(record)">重发</a>
        <!-- <a-divider type="vertical" />
        <a @click="handlDelete(record.id)">查看</a> -->
      </span>
    </a-table>
    <shortMessageModel ref="modalForm" @ok="modalFormOk"></shortMessageModel>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import JDate from '@/components/jeecg/JDate';
import { filterObj } from '@/utils/util';
import { uploadAction, postAction, downFile } from '@/api/manage';
import {
  shortMessageList,
  shortMessageUrl,
  shortMessageRetransmission
} from '@/api/shortMessage';
import shortMessageModel from './shortMessageModel.vue';
import customRender from '@/utils/customRender.js';
export default {
  name: 'shortMessage',
  // mixins:[JeecgListMixin],
  components: {
    JDate,
    shortMessageModel
  },
  data() {
    return {
      description: '产品报价管理页面',
      fileList: [],
      showDialog: false,
      format: 'YYYY-MM-DD HH:mm:ss',
      downloadUrl: '',
      showLead: false,
      uploading: false,
      selectedRowKeys: [],
      createTime: [],
      selectionRows: [], //table选中数据
      loading: false,
      empty: null,
      dataSource: [], //table数组数据
      superQueryParams: '',
      queryParam: {
        //查询数据
        mobile: '',
        content: '',
        startTime: '',
        endTime: '',
        status: undefined
      },
      ipagination: {
        //分页
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'mobile',
          width: 200
        },
        {
          title: '短信内容',
          align: 'center',
          dataIndex: 'content',
          ellipsis: true,
          width: 200
        },
        {
          title: '短信状态',
          align: 'center',
          dataIndex: 'status',
          width: 200,

          customRender: text => {
            if (text == 0) {
              return '发送失败';
            } else if (text == 1) {
              return '已发送';
            } else if (text == '') {
              return null;
            }
          }
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          width: 200,

          customRender: customRender
        },
        {
          title: '修改时间',
          align: 'center',
          sorter: true,
          dataIndex: 'updateTime',
          width: 200,

          customRender: customRender
        },

        {
          title: '发送失败信息',
          align: 'center',
          dataIndex: 'errInfo',
          customRender: customRender,
          width: 200
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        importExcelUrl: process.env.VUE_APP_CMS_SMSBIZ + '/sms/sendByExcel',
        getExcelTemplateUrl:
          process.env.VUE_APP_CMS_SMSBIZ + '/sms/getExcelTemplateUrl'
      },
      dictOptions: {},
      superFieldList: [],
      createValue: []
    };
  },
  created() {
    this.getList();
  },
  computed: {},
  methods: {
    initDictConfig() {},
    channel() {
      this.showDialog = true;
    },
    //删除
    handlDelete(id) {
      let that = this;
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.loadData();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      shortMessageList(params).then(res => {
        that.loading = true;
        if (res.success) {
          that.dataSource = res.result.records;
          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },
    //单条发送
    vertical(val) {
      this.$refs.modalForm.visible = true;
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.short = val;
    },
    // 文件上传
    beforeUpload(file) {
      this.fileList = [file];
      console.log(this.fileList);
      return false;
    },
    // 删除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    //下载模板
    // handleExportExcel() {
    //   shortMessageUrl().then(res => {
    //     let url = res.result;
    //     window.open(url);
    //   });
    // },
    handleExportExcel(fileName) {
      // console.log(this.wid);
      // let wid = this.wid;
      // if (this.id == '') {
      //   wid = this.wid;
      // } else {
      //   wid = this.id;
      // }
      if (!fileName || typeof fileName != 'string') {
        fileName = '导出文件';
      }

      downFile(this.url.getExcelTemplateUrl, {}).then(data => {
        if (!data) {
          this.$message.warning('文件下载失败');
          return;
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(
            new Blob([data], { type: 'application/vnd.ms-excel' }),
            fileName + '.xls'
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: 'application/vnd.ms-excel' })
          );
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName + '.xls');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    //上传
    upload() {
      let formData = new FormData();
      this.uploading = true;
      formData.set('file', this.fileList[0]);
      uploadAction(this.url.importExcelUrl, formData)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.uploading = false;
          this.fileList = [];
          this.showDialog = false;
          this.searchQuery();
        });
    },

    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.createTime = [];
      this.getList(1);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.getList();
    },
    //重发
    retransmission(record) {
      if (record.status == 1) {
        return this.$message.success('选择的数据已发送成功');
      }
      let result = [];
      result.push(record.id);
      shortMessageRetransmission({ idList: result }).then(res => {
        if (res.success) {
          this.getList();
          this.$message.success('操作成功');
        }
      });

      console.log(record);
    },
    // 批量重发
    retrieveBatch() {
      let result = this.selectionRows.map(item => {
        return item.id;
      });
      if (this.selectionRows.length <= 0) {
        return this.$message.warning('请选择一条数据');
      }
      shortMessageRetransmission({ idList: result }).then(res => {
        if (res.success) {
          this.getList();
          this.$message.success(res.message);
          this.onClearSelected();
        } else {
          // this.$message.warning('请选择一条记录');
          this.$message.warning(res.message);
        }
      });
      console.log(result);
    },
    handleChange(data, dateStrings) {
      this.createValue = data;
      this.createTime = dateStrings;
      let startTime = dateStrings[0];
      let endTime = dateStrings[1];
      this.queryParam.startTime = startTime;
      this.queryParam.endTime = endTime;
      console.log(this.queryParam, dateStrings);
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
